export default __webpack_public_path__ + "static/media/jswkoks_logo_white.2292b598.svg";